import { useState } from 'react';
import type { BannerItemType } from '@/app/components/shared/Community';
import { SITE } from '@/app/constants';
import { useFetch } from '@/app/hooks';
import type { ViduV1Spotlight } from '@/app/types';
import { viduListSpotlights } from '../apis';

const STATIC_FALLBACK_BANNERS: BannerItemType[] = [
  {
    id: 'static-feature-q3',
    type: 'feature',
    title: 'Q3',
    subtitle: '',
    redirect_url: '/create/character2video',
    cover_uri:
      SITE === 'china'
        ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/q3-banner-e350123f.webp'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/q3-banner-en-ab36475d.webp',
  },
  {
    id: 'static-feature-agent',
    type: 'feature',
    title: 'Agent',
    subtitle: '',
    redirect_url: '/project',
    cover_uri:
      SITE === 'china'
        ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/agent-zh-09b0e3dd.webp'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/agent-en-108bde04.webp',
  },
];

const transformSpotlight = (item: ViduV1Spotlight): BannerItemType => {
  const { id, activity, feature, display_mode } = item;

  return item.type === 'activity' && activity
    ? {
        id: id || '',
        type: 'activity',
        activity_id: activity.id || '',
        title: activity.title || '',
        subtitle: activity.subtitle || '',
        redirect_url: activity.link?.uri || '',
        cover_uri: activity.cover_uri || '',
        display_mode: display_mode,
      }
    : {
        id: id || '',
        type: 'feature',
        title: feature?.title || '',
        subtitle: feature?.subtitle || '',
        redirect_url: feature?.redirect_url || '',
        cover_uri: feature?.cover_uri || '',
        display_mode: display_mode,
      };
};

export const useGetBannerList = () => {
  const [carouselBanners, setCarouselBanners] = useState<BannerItemType[]>([]);
  const [fixedBanners, setFixedBanners] = useState<BannerItemType[]>([]);

  const { run: apiGetBannerList, loading } = useFetch(viduListSpotlights, {
    manual: true,
    onSuccess: ({ data }) => {
      const { spotlights = [] } = data || {};
      const carousel: BannerItemType[] = [];
      const fixed: BannerItemType[] = [];

      spotlights.forEach((item) => {
        const banner = transformSpotlight(item);
        if (!banner) return;

        if (banner.display_mode === 'fixed') {
          fixed.push(banner);
        } else {
          carousel.push(banner);
        }
      });

      setCarouselBanners(carousel.length > 0 ? carousel : STATIC_FALLBACK_BANNERS);
      setFixedBanners([...fixed.slice(0, 2), ...STATIC_FALLBACK_BANNERS].slice(0, 2));
    },
  });

  return {
    carouselBanners,
    fixedBanners,
    getBannerList: apiGetBannerList,
    getBannerListLoading: loading,
  };
};
